







import MobileMixin from "@/mixins/mobileMixin";
import Component, { mixins } from "vue-class-component";

@Component
export default class LoginLayout extends mixins(MobileMixin) {
  get version(): string[] {
    return this.$store.getters["getVersion"];
  }

  get isApp(): boolean {
    return this.$store.getters["getApp"];
  }
}
